module.exports = __webpack_public_path__ + "images/fontello.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/mavon-editor/dist/font/fontello.woff2
// module id = 949
// module chunks = 2